import React, { useContext, useEffect, useState } from 'react';
import { Drawer, Button, Dropdown, Menu } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, AppstoreAddOutlined, MoreOutlined } from '@ant-design/icons';
import { AddFlowSheetModal } from './FlowSheetCard/AddFlowSheetModal'
import { projectContext } from '@/layouts/MainLayout'
import { useRequest } from 'ahooks'
import { deleteTemplate, getTemplates } from '@/services/project/flowsheets'
import { useNavigate } from 'react-router'

const TemplatePanel: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { projectId } = useContext(projectContext)
  const [menuVisibleId, setMenuVisibleId] = useState<number | null>(null);
  const {data: templates = [], run} = useRequest(() => getTemplates(projectId), {manual: true})
  const navigate = useNavigate()

  useEffect(() => {
    if (open) run()
  }, [open]);

  const toFlowFile = (id) => {
    navigate(`/main/projects/${projectId}/templates/${id}`)
  }

  const handleMenuClick = async(key: string, template) => {
    const id = template.id
    if (key === 'edit') {
      
      AddFlowSheetModal.show({pId: projectId, flowsheet: template, isTemplate: true, onSuccess: () => {
        run();
      }})
    } else if (key === 'delete') {
      await deleteTemplate(id)
      run()
    } else if (key === 'open') {
      toFlowFile(id)
    }
    setMenuVisibleId(null);
  };

  const menu = (template) => (
    <Menu
      onClick={({ key }) => handleMenuClick(key, template)}
      items={[
        {
          key: 'edit',
          icon: <EditOutlined style={{ color: '#4CAF50' }} />,
          label: 'Edit',
        },
        {
          key: 'delete',
          icon: <DeleteOutlined style={{ color: '#F44336' }} />,
          label: 'Delete',
        },
      ]}
    />
  );

  const onCreate = () => {
    AddFlowSheetModal.show({pId: projectId, isTemplate: true, onSuccess: () => {
      run();
    }})
  }

  return (
    <>
      <Button icon={<AppstoreAddOutlined />} onClick={() => setOpen(true)}>Template</Button>
      <Drawer
        title="Template Management"
        placement="right"
        width={420}
        onClose={() => setOpen(false)}
        open={open}
        bodyStyle={{ background: '#fafbfc', padding: 24 }}
      >
        <div>
          {templates.map((tpl, idx) => (
            <div
              key={tpl.id}
              style={{
                border: '1px solid #eee',
                borderRadius: 12,
                background: '#fff',
                marginBottom: 24,
                position: 'relative',
                padding: 12,
                transition: 'border 0.2s',
              }}
            >
              <Dropdown
                overlay={menu(tpl)}
                trigger={['click']}
                placement="bottomRight"
                onOpenChange={visible => setMenuVisibleId(visible ? tpl.id : null)}
                open={menuVisibleId === tpl.id}
              >
                
                <Button
                  type="text"
                  icon={<MoreOutlined style={{fontSize: 24}} />}
                  style={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    boxShadow: 'none',
                  }}
                />
              </Dropdown>
              <div
                style={{
                  background: '#fafbfc',
                  borderRadius: 10,
                  padding: 12,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: 180,
                }}
              >
                <img
                  onClick={() => toFlowFile(tpl.id)}
                  src={'/images/default.jpg'}
                  alt={tpl.name}
                  style={{ maxWidth: '100%', maxHeight: 180, objectFit: 'contain' }}
                />
              </div>
              <div style={{ marginTop: 8, fontWeight: 500 }}>{tpl.name}</div>
              
            </div>
          ))}
          <div
            style={{
              border: '1.5px dashed #B2B8C6',
              borderRadius: 12,
              background: '#fff',
              minHeight: 120,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#3B7CFF',
              cursor: 'pointer',
              fontWeight: 500,
              fontSize: 16,
              marginTop: 8,
            }}
            onClick={onCreate}
          >
            <PlusOutlined style={{ fontSize: 24, marginBottom: 4 }} />
            New Template
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default TemplatePanel;